import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var RealEstate = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.719 19.528 23.516 3.45c-.9-.599-2-.599-2.9 0L.314 19.53c-.4.299-.4.898-.1 1.198.3.4.9.4 1.2.1l3.3-2.597v19.375c0 1.997 1.9 3.395 3.9 3.395h26.904c2 0 3.9-1.398 3.9-3.395V18.33l3.2 2.596c.4.3.9.2 1.2-.1.3-.399.2-.998-.1-1.298Zm-6.1 18.176c0 .7-.801 1.598-2.101 1.598H8.615c-1.3 0-2.1-.899-2.1-1.598V16.932L21.616 4.848c.2-.2.6-.2.8 0l15.102 12.084v20.772h.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.117 27.418c-.3-.6-.8-1.099-1.4-1.398-.8-.5-1.9-.8-2.9-1.099V18.63c.7.1 1.3.4 1.8.8.7.599 1.2 1.298 1.2 2.197 0 .499.4.898.9.898s.9-.4.9-.899c0-1.497-.8-2.796-1.9-3.595-.8-.599-1.8-.998-2.9-1.198v-1.199c0-.499-.4-.898-.9-.898s-.9.399-.9.898v1.199c-2.601.4-4.701 2.297-4.701 4.793 0 .8.2 1.598.5 2.198.3.599.8 1.098 1.4 1.398.8.5 1.9.799 2.8 1.098v6.292c-1.8-.3-3-1.698-3-2.996 0-.5-.4-.899-.9-.899s-.9.4-.9.899c0 2.497 2.1 4.494 4.7 4.794v1.198c0 .5.4.899.9.899s.9-.4.9-.899V34.41c2.6-.3 4.801-2.297 4.801-4.794.1-.799 0-1.598-.4-2.197Zm-6-2.896c-.8-.2-1.4-.4-1.901-.7-.3-.2-.6-.499-.8-.798-.2-.3-.3-.7-.3-1.299 0-1.398 1.2-2.696 3-2.996v5.793Zm1.8 8.089v-5.892c.8.2 1.4.4 1.9.699.4.2.6.5.8.799.2.3.3.799.3 1.398 0 1.398-1.2 2.696-3 2.996Z"
  }));
});
RealEstate.displayName = 'RealEstate';
RealEstate.defaultProps = {
  'aria-label': 'RealEstate'
};
export default RealEstate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/RealEstate.js
// module id = 3076
// module chunks = 11